import { z } from 'zod';
import { FlavorSchema } from './common';

export const HANDLE_RE = /^[a-z0-9_]{3,20}$/u;
export const VIBE_TAGS = [
  'music',
  'nightlife',
  'football',
  'gaming',
  'art',
  'foodie',
  'movies',
  'books',
  'startup',
  'photography',
  'dance',
  'chill',
] as const;
export const VibeTagSchema = z.enum(VIBE_TAGS);

export const ProfileSchema = z.object({
  handle: z.string().regex(HANDLE_RE),
  vibeEmoji: z.string().min(1).max(8),
  flavor: FlavorSchema,
  pronouns: z.string().max(20).nullable(),
  bio: z.string().max(140).nullable(),
  tags: z.array(VibeTagSchema).max(5),
  /** Default Glow duration in minutes. */
  glowDefaultMinutes: z.union([z.literal(30), z.literal(60), z.literal(120), z.literal(180)]),
  sharePreciseLocation: z.boolean(),
});
export type Profile = z.infer<typeof ProfileSchema>;

/* POST /api/profile/onboard — completes the terms + profile step. */
export const OnboardSchema = z.object({
  acceptedAge18: z.literal(true),
  acceptedTerms: z.literal(true),
  acceptedLocation: z.literal(true),
  /** Versions of each accepted document, echoed from the client. */
  termsVersion: z.string().min(1).max(20),
  handle: z.string().regex(HANDLE_RE),
  vibeEmoji: z.string().min(1).max(8),
  flavor: FlavorSchema,
  pronouns: z.string().max(20).optional(),
  bio: z.string().max(140).optional(),
  tags: z.array(VibeTagSchema).max(5).default([]),
});
export type Onboard = z.infer<typeof OnboardSchema>;

/* PATCH /api/profile — settings edits. */
export const UpdateProfileSchema = ProfileSchema.partial().omit({ handle: true });
export type UpdateProfile = z.infer<typeof UpdateProfileSchema>;

export const ProfileResponseSchema = z.object({ profile: ProfileSchema });
export type ProfileResponse = z.infer<typeof ProfileResponseSchema>;

/* GET /api/profile/handle-available?handle=xyz */
export const HandleAvailableResponseSchema = z.object({
  handle: z.string(),
  available: z.boolean(),
});
export type HandleAvailableResponse = z.infer<typeof HandleAvailableResponseSchema>;
